import React, { useMemo } from 'react'
import Select, { components } from 'react-select'
import PropTypes from 'prop-types'

import { PRODUCT_SELECTION_TYPE, SELECTOR_STYLE, SINGLE_SELECTION } from '@common'
import { useIsMobile } from '@hooks'

const formatOptionLabel = ({ label, sellPrice, isDisabled }, { context }) => {
    if (context === 'menu') {
        return (
            <div style={{ display: 'flex', gap: '32px', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{label}</span>
                {isDisabled ?
                    <span className="disabled text-danger">Sold Out</span>
                :   sellPrice !== 0 && (
                        <span className="d-flex" style={{ whiteSpace: 'nowrap' }}>
                            + ${sellPrice?.toFixed(2)}
                        </span>
                    )
                }
            </div>
        )
    }
    return label
}

const CustomSingleValue = props => {
    return (
        <components.SingleValue {...props}>
            {props.data.label} {props.data.isTakeaway && `($${props.data.sellPrice})`}
        </components.SingleValue>
    )
}

const ProductSelectionSelector = ({ value, onChange, options, type, quantity }) => {
    const isMobile = useIsMobile()
    const isSingle = useMemo(() => SINGLE_SELECTION.includes(type) || quantity === 1, [type, quantity])

    return (
        <Select
            value={value}
            options={options}
            onChange={onChange}
            placeholder="Select..."
            styles={SELECTOR_STYLE}
            formatOptionLabel={formatOptionLabel}
            components={{ SingleValue: CustomSingleValue }}
            type={type}
            isClearable
            isMulti={!isSingle}
            closeMenuOnSelect={!isMobile}
            blurInputOnSelect={isSingle}
            isSearchable={false}
        />
    )
}

ProductSelectionSelector.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    type: PropTypes.oneOf(Object.values(PRODUCT_SELECTION_TYPE)).isRequired,
}

export default ProductSelectionSelector
